<template>
  <b-card class="h-100" border-variant="success" no-body>
    <b-card-body>
      <h2 class="card-title h4" :class="featured ? 'font-weight-bold text-uppercase' : ''">{{title}}</h2>
      <div class="metric-text">
        <fitty :options="{minSize: 10, maxSize: 40}">
          <template v-slot:content>
            <p :class="featured ? 'text-primary' : ''">{{ isCurrency ? toCurrency(data) : data }}</p>
          </template>
        </fitty>
      </div>
      <div v-if="compText" class="profit-indicator">
        <p>
          <span :class="compColorFunc(compData)">{{toPercent(Math.abs(compData))}}</span>
          <!--<mark :style="compColorFunc(compData)" v-html="compDirectionFunc(compData)"></mark>-->
          {{compText}}
        </p>
      </div>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  props: {
    title: { type: String, default: "" },
    data: { type: Number, default: 0 },
    isCurrency: { type: Boolean, default: false },
    compData: { type: Number, default: 0 },
    compText: { type: String, default: "" },
    //compColorFunc: { type: Function, default: (val) => val > 0 ? "color: #dc3545;background-color: white;" : "color: #28a745;background-color: white;"  },
    compDirectionFunc: {
      type: Function,
      default: (val) => (val > 0 ? "&#9650;" : "&#9660;"),
    },
    compColorFunc: {
      type: Function,
      default: (val) => (val > 0 ? "negative" : "positive"),
    },
    featured: { type: Boolean, default: false },
  },
  methods: {
    toCurrency(val) {
      if (val >= 1000000000) {
        let newVal = val / 1000000000;
        if (newVal >= 100) return `$${Math.trunc(newVal)}b`;
        return `$${Number(newVal.toFixed(1))}b`;
      }
      if (val >= 1000000) {
        let newVal = val / 1000000;
        if (newVal >= 100) return `$${Math.trunc(newVal)}m`;
        return `$${Number(newVal.toFixed(1))}m`;
      }
      if (val >= 1000) {
        let newVal = val / 1000;
        if (newVal >= 100) return `$${Math.trunc(newVal)}k`;
        return `$${Number(newVal.toFixed(1))}k`;
      }
      return "$" + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toPercent(num) {
      return parseFloat((num * 100).toFixed(2)) + "%";
    },
  },
};
</script>

<style scoped>
.metric-text {
  font-size: 2.5rem;
  line-height: 1;
  padding-top: 10px;
}
</style>